import React, { useCallback, useEffect, useState, useRef } from 'react';
import { Accordion } from 'flowbite-react';
import { Link, useNavigate } from 'react-router-dom';
import { Collapse } from 'flowbite';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { menucontrol } from '../../features/togglebuttonSlice';
import { updatedCart } from '../../features/updatedCartSlice';
import { getAsync } from '../helper/axiosHelper';
import { addTitle, addTitlePermanent, addTitleEmergency } from '../../features/campaignMenuSlice';
import { toast } from 'react-toastify';
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import MainMenu from './MainMenu';
import MainMenuTwo from './MainMenuTwo';
import Loader from '../Loader/Loader';

const PublicPortalTopMenu = () => {
  const updatedCartValue = useSelector((state) => state.updatedCart.updatedCart);
  const valuecart = useSelector((state) => state.usercart.usercart);
  const isActive = useSelector((state) => state.toggle.isActive);
  const [cartItems, setCartItems] = useState([]);
  const [mobileTopHeader, setMobileTopHeader] = useState(false);
  const [isSubmenuOpen, setIsSubmenuOpen] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [projectsLoading, setProjectsLoading] = useState(false);
  const [projectCardsData, setProjectCardsData] = useState([]);
  const [selectedRadioButton, setSelectedRadioButton] = useState(1);
  const [selectedProject, setSelectedProject] = useState();
  const [amount, setAmount] = useState(0);
  const [subCampaigns, setSubCamaigns] = useState([]);
  const [subParmanent, setSubParmanent] = useState([]);
  const [subEmergency, setSubEmergency] = useState([]);
  const [selectProjectGuid, setSelectProjectGuid] = useState('');
  const [openMenu, setOpenMenu] = useState(null);
  const token = localStorage.getItem('token');
  const role = localStorage.getItem('role');
  const cardsContainerRef = useRef(null);

  const toggleMenu = (menuName) => {
    setOpenMenu(openMenu === menuName ? null : menuName);
  };

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();

  let $targetEl = null;
  let $triggerEl = null;

  // optional options with default values and callback functions
  const options = {
    onCollapse: () => {
      $targetEl.style.display = 'none'; // Hide $targetEl
    },
    onExpand: () => {
      $targetEl.style.display = ''; // Hide $targetEl
    },
    onToggle: () => {},
  };

  const instanceOptions = {
    id: 'targetEl',
    override: true,
  };
  let collapse = null;

  useEffect(() => {
    localStorage.setItem('isHome', true);
    $targetEl = document.getElementById('targetEl');
    $triggerEl = document.getElementById('triggerEl');
    collapse = new Collapse($targetEl, $triggerEl, options, instanceOptions);
    window.addEventListener('load', collapseAt1024px);
    window.addEventListener('resize', collapseAt1024px);
    // (async () => {
    //   const response = await getAsync('APIClient/CampaignModuleTypesSHJC');
    //   if (response) {
    //     dispatch(addTitle(response?.data));
    //     setSubCamaigns(response?.data);
    //   }
    // })();
    (async () => {
      try {
        // 1st API Call
        const campaignRes = await getAsync('APIClient/CampaignModuleTypesSHJC');
        if (campaignRes) {
          dispatch(addTitle(campaignRes?.data));
          setSubCamaigns(campaignRes?.data);
        }

        const permanentRes = await getAsync('APIClient/permanentcampaignsmodulesSHJC');
        if (permanentRes) {
          dispatch(addTitlePermanent(permanentRes?.data)); // Example action
          setSubParmanent(permanentRes?.data); // Example state update
        }

        // 3rd API Call
        const emergencyRes = await getAsync('APIClient/EmergencyCampaignsMoudulesSHJC');
        if (emergencyRes) {
          dispatch(addTitleEmergency(emergencyRes?.data)); // Example action
          setSubEmergency(emergencyRes?.data); // Example state update
        }
      } catch (error) {
        toast.error(t('Something went wrong, Please try again!'));
        // Aap yahan toast ya error message bhi dikha sakte ho
      }
    })();
  }, []);

  const collapseAt1024px = () => {
    if (window.innerWidth <= 1024) {
      collapse?.collapse(); // Collapse the element
    } else {
      collapse?.expand(); // Expand the element if screen width is greater than 1024px
    }
  };

  window.addEventListener('load', collapseAt1024px);
  window.addEventListener('resize', collapseAt1024px);

  useEffect(() => {
    const storedData = localStorage.getItem('cart');
    if (storedData) {
      setTimeout(() => {
        setCartItems(JSON.parse(storedData));
        dispatch(updatedCart(false));
      }, 3000);
    }
  }, [updatedCartValue]);

  useEffect(() => {
    getNewProjects();
  }, []);

  const aboutNested = [
    { name: 'About', path: '/about' },
    { name: 'Vision & Mission', path: '/misionvision' },
    { name: 'Our Policy', path: '/Ourpolicy' },
    { name: 'Board of Directors', path: '/boardofDirectors' },
    { name: 'Executive management', path: '/executivemanagement' },
    { name: 'Our Offices', path: '/Ouroffices' },
    { name: 'Contact', path: '/contact' },
  ];

  const innitiativePrograms = [
    { name: 'Zakat', path: '/Zakat' },
    // { name: 'Evidence of goodness', path: '/' },
    { name: 'Jude Gifts', path: '/JudeGifts' },
    { name: 'Dirham Al-Hamd', path: '/darmhamd' },
    { name: 'Righteousness towards the dead', path: '/righteousnessDead' },
    { name: 'Ambassadors of Goodness', path: '/Goodnessservices' },
    { name: 'Physical Donation', path: '/Physicaldonations' },
    // { name: 'Gift', path: '/Gift' },
    { name: 'You have Same', path: '/Youhavesame' },
  ];

  const MediaCenter = [
    { name: 'X', path: 'https://x.com/shj_charity' },
    { name: 'Youtube', path: 'https://www.youtube.com/@Shjcharity1' },
    { name: 'Facebook', path: 'https://www.facebook.com/SharjahCharity' },
    { name: 'Instagram', path: 'https://www.instagram.com/shj_charity' },
  ];

  const handleClick = () => {
    // dispatch(menucontrol(true));
    // localStorage.setItem('isHome', true);
    window.location.href = role === 'Admin' ? '/admin' : `/user`;
  };

  const handleHamburgerClick = () => {
    setMobileTopHeader(true);
  };
  const handleCloseClick = () => {
    setMobileTopHeader(false);
  };

  const toggleSubmenu = () => {
    setIsSubmenuOpen(true);

    setTimeout(() => {
      setIsSubmenuOpen(false);
    }, 300);
  };

  const getNewProjects = async () => {
    setProjectsLoading(true);
    // if(id){
    // setActiveTab(id);
    // }

    await getAsync(`APIClient/Floater`)
      .then((res) => {
        const result = res?.data;

        setProjectCardsData(result);
        setProjectsLoading(false);
        // setTabs(result);
        // setProjectTypes(result);
      })
      .catch((err) => {
        toast.error(t('Something went wrong, Please try again!'));
        setProjectsLoading(false);
      });
  };

  const toggleExpand = () => setIsExpanded(!isExpanded);

  const scrollSection = (container, direction) => {
    if (container) {
      const scrollAmount = 100; // Adjust this value as needed
      container.scrollBy({ left: scrollAmount * direction, behavior: 'smooth' });
    }
  };

  // radio buttons in floater
  const handleOnChange = (id) => {
    if (id) {
      setSelectedRadioButton(id);
    }
  };

  const dataObject = {
    paymentMethodId: selectedRadioButton || 1,
    amount,
    required: true,
  };

  const DonateHandle = () => {
    if (amount > 0) {
      if (amount == 0) {
        return;
      } else {
        if (selectProjectGuid == '') {
          toast.error(`${t('Please Select Project First')}`);
        } else {
          const link = `/externalPayment/${selectProjectGuid.id}/${selectProjectGuid.id}/${6}/${selectProjectGuid?.projectTypeIdInt}`;
          navigate(link, { state: { paymentInfo: dataObject } });
          setIsExpanded(false);
          setAmount(0);
        }
      }
    } else {
      toast.error(`${t('Amount must be greater than 0')}`);
    }
  };
  const handleLogout = useCallback(() => {
    // Handle logout logic here
    //localStorage.clear();
    localStorage.removeItem('token');
    localStorage.removeItem('upid');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('expirationDate');
    localStorage.removeItem('userName');
    localStorage.removeItem('name');
    localStorage.removeItem('role');
    localStorage.removeItem('email');
    localStorage.removeItem('statusCode');
    localStorage.removeItem('message');
    localStorage.removeItem('mobile');
    localStorage.setItem('isHome', true);
    dispatch(menucontrol(true));
    window.location.href = '/donorLogin';
    toast.success(t('msg_logoutSuccess'));
  }, [dispatch, t]);

  return (
    <>
      <header className="absolute top-0">
        {/* Top-Right Corner */}

        <div className={`fixed top-36 ${isActive ? 'right-0' : 'left-0'}`} style={{ zIndex: 5 }}>
          <div
            className={`flex items-center cursor-pointer transition-transform duration-1000 ease-in-out shadow-md ${isActive ? 'rounded-l-full pr-2' : 'rounded-r-full pl-2'} bg-white ${isExpanded ? 'hidden' : 'flex'}`}
            onClick={toggleExpand}
          >
            <span className="text-customgreen font-bold p-2">{t('Quick Donation')}</span>
            <div className={`bg-customorange px-2 py-2 ${isActive ? 'rounded-l-full' : 'rounded-r-full '}`}>
              <span className={`bg-white rounded-full text-customorange px-2  text-xl`}>+</span>
            </div>
          </div>

          <div
            className={`fixed top-36 w-72 sm:w-96 bg-white shadow-lg rounded-xl transition-all duration-500 ease-in-out ${isActive && isExpanded ? 'animation-slideIn ' : ''} ${!isActive && isExpanded ? 'animation-slideInLeft ' : ''}`}
            style={{ zIndex: 5 }}
          >
            {isExpanded && (
              <>
                {/* Close Button */}
                <div
                  className={`flex border-customorange items-center bg-slate-100 ${isActive ? 'rounded-l-full border-l-3' : 'rounded-r-full border-r-3'} justify-between`}
                >
                  <span className="font-bold text-center text-lg text-customorange flex-grow p-2">
                    {t('Quick Donation')}
                  </span>
                  <button
                    className={`text-white ${isActive ? 'rounded-tl-xl' : 'rounded-tr-xl'} bg-customorange border-2 border-customorange w-10 text-4xl`}
                    onClick={toggleExpand}
                  >
                    ×
                  </button>
                </div>

                {/* Project Data Section */}
                <div className="flex flex-col items-center ">
                  <h3 className="text-lg font-semibold text-customgreen my-1">{t('Sadaqat')}</h3>
                  {projectsLoading ? (
                    <div className="h-24 w-24 overflow-hidden">
                      <Loader />
                    </div>
                  ) : (
                    <div className="relative w-full flex items-center">
                      {/* Left Scroll Button for Cards */}
                      <button
                        onClick={() => scrollSection(cardsContainerRef.current, -1)}
                        className="absolute left-0 z-10 p-2"
                      >
                        <ArrowBackIosIcon />
                      </button>

                      {/* Card Container */}
                      <div
                        ref={cardsContainerRef}
                        className="flex gap-x-4 overflow-x-auto mx-8 scrollbar-thin scrollbar-thumb-customgreen scrollbar-track-gray-200"
                      >
                        {projectCardsData?.map((card, index) => (
                          <div
                            key={index}
                            className={`${selectedProject == index ? 'bg-green-50 shadow-lg border-1' : 'bg-white-50'} min-w-[40%] max-w-[40%] max-h-48 p-2 border-2 border-gray-100  shadow-md rounded-lg mb-3 flex-shrink-0 overflow-y-auto`}
                          >
                            <div className="flex flex-col justify-center items-center text-center h-full">
                              <h4 className="text-sm text-customgreen font-semibold mb-2">
                                {`${isActive ? card?.title_AR.slice(0, 13) : card?.title_EN.slice(0, 13)}...`}
                              </h4>

                              <button
                                className={`${selectedProject == index ? 'bg-customgreen text-white' : ''} w-full md:w-2/3 px-2 text-customgreen border-1 border-customgreen 
    hover:bg-customgreen hover:text-white transition duration-300 ease-in-out 
    rounded-md mt-2 md:mt-0`}
                                onClick={(e) => {
                                  setSelectedProject(index);
                                  setSelectProjectGuid({...setSelectProjectGuid,id: card?.id, projectTypeIdInt:card?.projectTypeIdInt});
                                }}
                              >
                                {t('Select')}
                              </button>
                            </div>
                          </div>
                        ))}
                      </div>

                      {/* Right Scroll Button for Cards */}
                      <button
                        onClick={() => scrollSection(cardsContainerRef.current, 1)}
                        className="absolute right-0 z-10 p-2"
                      >
                        <ArrowForwardIosOutlinedIcon />
                      </button>
                    </div>
                  )}
                </div>

                <div className="px-7 flex flex-col gap-2 pt-2 pb-3">
                  {/* radio buttons code  */}

                  <div className="flex gap-3 justify-between my-2">
                    {/* One Time Payment Radio Button */}

                    <div
                      onClick={() => {
                        handleOnChange(1);
                      }}
                      className={`w-full cursor-pointer flex items-center border-1 ${
                        selectedRadioButton == 1
                          ? 'border-customgreen dark:border-customgreen bg-green-50 shadow-md'
                          : 'border-gray-200'
                      } rounded-full dark:border-gray-700 p-1`}
                    >
                      <input
                        onChange={(e) => {
                          handleOnChange(1);
                        }}
                        id={`bordered-radio-1`}
                        type="radio"
                        value={1}
                        name={`paymentss`}
                        className="text-customgreen text-sm cursor-pointer rounded-lg focus:ring-customgreen focus:border-customgreen block"
                        checked={selectedRadioButton === 1} // Use checked for controlled input
                      />
                      <label htmlFor={`bordered-radio-1`} className="w-4/5 ms-2 text-sm cursor-pointer font-medium">
                        {t('One Time')}
                      </label>
                    </div>

                    {/* Monthly Payment Radio Button */}
                    <div
                      onClick={() => handleOnChange(2)}
                      className={`w-full cursor-pointer flex items-center border-1 ${
                        selectedRadioButton == 2
                          ? 'border-customgreen dark:border-customgreen bg-green-50 shadow-md'
                          : 'border-gray-200'
                      } rounded-full dark:border-gray-700 p-1`}
                    >
                      <input
                        onChange={(e) => {
                          handleOnChange(2);
                        }}
                        id={`bordered-radio-2`}
                        type="radio"
                        value={2}
                        name={`payment-`}
                        className="text-customgreen text-sm cursor-pointer rounded-lg focus:ring-customgreen focus:border-customgreen block"
                        checked={selectedRadioButton === 2} // Use checked for controlled input
                      />
                      <label htmlFor={`bordered-radio-2`} className="w-4/5 ms-2 text-sm cursor-pointer font-medium">
                        {t('Monthly')}
                      </label>
                    </div>
                  </div>

                  {/* Input Field */}
                  <div className="flex items-center mb-2">
                    {/* <label htmlFor="amount" className="mr-2"></label> */}
                    <input
                      placeholder={t('Enter Amount')}
                      id="amount"
                      maxLength="7"
                      type="text"
                      onInput={(event) => {
                        const { value } = event.target;
                        const regex = /^\d+(\.\d{0,2})?$/;

                        if (value === '') {
                          setAmount('');
                        } else if (regex.test(value)) {
                          setAmount(value);
                        } else {
                          event.target.value = value.slice(0, -1);
                        }
                      }}
                      className="focus:border-customorange text-sm border border-gray-100 focus:ring-1 focus:ring-customorange rounded-md w-full py-1 px-2"
                      // value={selectedAmount}
                      // onChange={(e) => setSelectedAmount(e.target.value)}
                    />
                  </div>

                  {/* Donate Now Button */}
                  <button className="w-full py-1 bg-customgreen text-white rounded-full" onClick={DonateHandle}>
                    {t('Donate Now')}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>

        {/* Mobileview menu starts*/}
        {mobileTopHeader && (
          <div className=" overflow-y-auto">
            <div
              className={`xl:hidden  text-white maindiv fixed z-30  ${isActive ? 'right-0' : ' left-0'}  min-h-full w-2/3 bg-green-50 overflow-y-auto h-screen`}
            >
              <div className={`closebuttondiv p-2 mx-2 flex  justify-end`}>
                <button
                  onClick={handleCloseClick}
                  className=" text-customgreen rounded-md hover:bg-customgreen hover:text-white"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="size-6"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              <div className="bg-green-50  topmenu ">
                <ul className=" p-2">
                  <li className={`flex flex-col items-center`}>
                    <div className="text-customgreen w-4/5">
                      {' '}
                      <Accordion collapseAll className=" text-center !border-none ">
                        <div className={` ${isActive ? 'text-right' : 'text-left'}`}>
                          <Link
                            to={'/'}
                            onClick={handleCloseClick}
                            className="accordion-heading  dark:divide-gray-0 p-2 divide-y-0 divide-gray-0 focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen hover:text-customgreen "
                          >
                            {t('nav_home')}
                          </Link>
                        </div>
                        <Accordion.Panel className="text-customgreen!">
                          <Accordion.Title className="accordion-heading  dark:divide-gray-0 p-2 divide-y-0 divide-gray-0 focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen hover:text-customgreen">
                            {t('about')}
                          </Accordion.Title>
                          <Accordion.Content
                            className={`p-2 text-left bg-white  ${isActive ? 'text-right ' : 'text-left '}`}
                          >
                            <ul className="">
                              {aboutNested.map((_, i) => (
                                <li className=" focus:ring-gray-50 dark:focus:ring-gray-0 " key={i}>
                                  <Link
                                    onClick={handleCloseClick}
                                    className="accordion-children text-customgreen hover:text-customgreen "
                                    to={_?.path}
                                  >
                                    {t(`${_?.name}`)}
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          </Accordion.Content>
                        </Accordion.Panel>

                        <Accordion.Panel className="text-customgreen!">
                          <Accordion.Title className="accordion-heading dark:divide-gray-0 p-2 divide-y-0 divide-gray-0 focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen hover:text-customgreen">
                            {t('Campaigns')}
                          </Accordion.Title>
                          <Accordion.Content
                            className={`dark:divide-gray-0 p-2 divide-y-0 divide-gray-0 focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen bg-white ${isActive ? 'text-right' : 'text-left'}`}
                          >
                            <ul className={`flex flex-col !gap-2 ${isActive ? 'mr-2 text-right' : 'ml-2 text-left'} `}>
                              <li className="dark:focus:ring-gray-0 !text-customgreen">
                                <div className="hover:text-customgreen">
                                  {' '}
                                  {/* Changed from Link to div */}
                                  <Accordion.Title
                                    onClick={() => toggleMenu('seasonal')}
                                    className="accordion-heading  dark:divide-gray-0 p-2 divide-y-0 divide-gray-0 focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen hover:text-customgreen cursor-pointer" /* Added cursor-pointer */
                                  >
                                    {t('Seasonal Campaigns')}
                                  </Accordion.Title>
                                  {openMenu === 'seasonal' && (
                                    <Accordion.Content
                                      className={`p-2 text-left  ${isActive ? 'text-right mr-2' : 'text-left ml-2'}`}
                                    >
                                      {subCampaigns?.map((data, index) => (
                                        <Link key={index} to={`/CampaignDonation/${data?.moduleID}`}>
                                          <li
                                            onClick={handleCloseClick}
                                            className="accordion-children dark:divide-gray-0 p-2 divide-y-0 divide-gray-0 dark:focus:ring-gray-0 text-customgreen hover:text-customgreen"
                                          >
                                            {t(`${isActive ? data?.title_AR : data?.title_EN}`)}
                                          </li>
                                        </Link>
                                      ))}
                                    </Accordion.Content>
                                  )}
                                </div>
                              </li>

                              <li className="dark:focus:ring-gray-0 !text-customgreen">
                                <div className="hover:text-customgreen">
                                  {' '}
                                  {/* Changed from Link to div */}
                                  <Accordion.Title
                                    onClick={() => toggleMenu('permanent')}
                                    className="accordion-heading  dark:divide-gray-0 p-2 divide-y-0 divide-gray-0 focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen hover:text-customgreen cursor-pointer" /* Added cursor-pointer */
                                  >
                                    {t('Permanent Campaigns')}
                                  </Accordion.Title>
                                  {openMenu === 'permanent' && (
                                    <Accordion.Content
                                      className={`p-2 text-left  ${isActive ? 'text-right mr-2' : 'text-left ml-2'}`}
                                    >
                                      {subParmanent?.map((data, index) => (
                                        <Link key={index} to={`/PermanentCampaigns/${data?.moduleID}`}>
                                          <li
                                            onClick={handleCloseClick}
                                            className="accordion-children dark:divide-gray-0 p-2 divide-y-0 divide-gray-0 dark:focus:ring-gray-0 text-customgreen hover:text-customgreen"
                                          >
                                            {t(`${isActive ? data?.title_AR : data?.title_EN}`)}
                                          </li>
                                        </Link>
                                      ))}
                                    </Accordion.Content>
                                  )}
                                </div>
                              </li>

                              <li className="dark:focus:ring-gray-0 !text-customgreen">
                                <div className="hover:text-customgreen">
                                  {' '}
                                  {/* Changed from Link to div */}
                                  <Accordion.Title
                                    onClick={() => toggleMenu('emergency')}
                                    className="accordion-heading  dark:divide-gray-0 p-2 divide-y-0 divide-gray-0 focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen hover:text-customgreen cursor-pointer" /* Added cursor-pointer */
                                  >
                                    {t('Emergency Campaigns')}
                                  </Accordion.Title>
                                  {openMenu === 'emergency' && (
                                    <Accordion.Content
                                      className={`p-2 text-left  ${isActive ? 'text-right mr-2' : 'text-left ml-2'}`}
                                    >
                                      {subEmergency?.map((data, index) => (
                                        <Link key={index} to={`/EmergencyCampaigns/${data?.moduleID}`}>
                                          <li
                                            onClick={handleCloseClick}
                                            className="accordion-children dark:divide-gray-0 p-2 divide-y-0 divide-gray-0 dark:focus:ring-gray-0 text-customgreen hover:text-customgreen"
                                          >
                                            {t(`${isActive ? data?.title_AR : data?.title_EN}`)}
                                          </li>
                                        </Link>
                                      ))}
                                    </Accordion.Content>
                                  )}
                                </div>
                              </li>
                            </ul>
                          </Accordion.Content>
                        </Accordion.Panel>

                        <Accordion.Panel className="bg-green-50">
                          <Accordion.Title className="accordion-heading dark:divide-gray-0 p-2 divide-y-0 divide-gray-0 focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen hover:text-customgreen   ">
                            {t('Initiatives_and_programs')}
                          </Accordion.Title>
                          <Accordion.Content
                            className={`p-2 text-left bg-white  ${isActive ? 'text-right ' : 'text-left '}`}
                          >
                            <ul className=" ">
                              {innitiativePrograms?.map((_, i) => (
                                <Link className="hover:text-customgreen" to={_?.path} onClick={handleCloseClick}>
                                  <li className=" focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen " key={i}>
                                    {t(`${_?.name}`)}
                                  </li>
                                </Link>
                              ))}
                              <Accordion.Panel className="bg-green-50">
                                <Accordion.Content className="p-2 bg-white text-center"></Accordion.Content>
                              </Accordion.Panel>
                            </ul>
                          </Accordion.Content>
                        </Accordion.Panel>

                        <Accordion.Panel className="bg-green-50">
                          <Accordion.Title className="accordion-heading dark:divide-gray-0 p-2 divide-y-0 divide-gray-0 focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen  hover:text-customgreen">
                            {t('media').charAt(0).toUpperCase() + t('media').slice(1)}
                          </Accordion.Title>
                          <Accordion.Content
                            className={`p-2 text-left bg-white  ${isActive ? 'text-right ' : 'text-left '}`}
                          >
                            <ul className=" ">
                              {MediaCenter.map((_, i) => (
                                <li
                                  className="accordion-children focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen "
                                  key={i}
                                >
                                  <a
                                    className="hover:text-customgreen "
                                    target="_blank"
                                    href={_?.path}
                                    onClick={handleCloseClick}
                                    rel="noreferrer"
                                  >
                                    {t(`${_?.name}`)}
                                  </a>
                                </li>
                              ))}
                              <li className="accordion-children focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen ">
                                <Link
                                  className="hover:text-customgreen "
                                  to={'/PressRelease'}
                                  onClick={handleCloseClick}
                                >
                                  {t('navItem_pressRelease')}
                                </Link>
                              </li>
                              <li className="accordion-children focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen ">
                                <Link
                                  className="hover:text-customgreen"
                                  to={'/PhotoGallery'}
                                  onClick={handleCloseClick}
                                >
                                  {t('navItem_photoGallery')}
                                </Link>
                              </li>
                              <li className="accordion-children focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen ">
                                <Link className="hover:text-customgreen" to={'/Infographic'} onClick={handleCloseClick}>
                                  {t('navItem_infographic')}
                                </Link>
                              </li>
                              <li className="accordion-children focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen ">
                                <Link
                                  className="hover:text-customgreen"
                                  to={'/SuccessStory'}
                                  onClick={handleCloseClick}
                                >
                                  {t('navItem_successStory')}
                                </Link>
                              </li>
                              <li className="accordion-children focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen ">
                                <Link
                                  className="hover:text-customgreen"
                                  to={'/VideoGallery'}
                                  onClick={handleCloseClick}
                                >
                                  {t('navItem_videoGallery')}
                                </Link>
                              </li>
                              <li className="accordion-children focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen ">
                                <Link
                                  className="hover:text-customgreen"
                                  to={'/publicPortalDownloadcenter'}
                                  onClick={handleCloseClick}
                                >
                                  {t('Download Center')}
                                </Link>
                              </li>
                            </ul>
                          </Accordion.Content>
                        </Accordion.Panel>

                        <div className={` ${isActive ? 'text-right' : 'text-left'}`}>
                          <Link
                            to={'/VolunteerWithus'}
                            onClick={handleCloseClick}
                            className="accordion-heading  dark:divide-gray-0 p-2 divide-y-0 divide-gray-0 focus:ring-gray-50 dark:focus:ring-gray-0 text-customgreen hover:text-customgreen "
                          >
                            {t('Volunteer_us')}
                          </Link>
                        </div>
                      </Accordion>
                    </div>
                  </li>
                </ul>
              </div>
              <div className="mainmenu   p-2 w-4/5 mx-auto">
                <MainMenuTwo handleCloseClick={handleCloseClick} />
                <Link to={'/GeneralDonation'}>
                  <button
                    type="button"
                    className="text-white  mt-4 px-4  h-10 bg-gradient-to-r  from-customgreen to-customorange hover:from-customorange hover:to-customgreen focus:ring-4 focus:outline-none focus:ring-customgreen font-bold rounded-full   text-md   text-center dark:bg-customgreen dark:hover:bg-hovergreen dark:focus:ring-customgreen"
                  >
                    {t('General Donation')}
                  </button>
                </Link>
              </div>
            </div>
          </div>
        )}

        {/* Mobileview menu ends*/}
        <nav
          data-aos="fade-down"
          data-aos-easing="linear"
          data-aos-duration="1500"
          className="xl:bg-white fixed z-20 bg-gray-200 w-full font-custom "
        >
          <button
            id="triggerEl"
            type="button"
            onClick={handleHamburgerClick}
            className={`p-2 w-10 h-10 xl:hidden text-sm z-30 text-gray-500 rounded-lg absolute hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 ${isActive ? 'right-3' : 'left-3 '}`}
            aria-expanded="false"
          >
            <span className="sr-only">Open main menu</span>
            <svg className="w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 14">
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M1 1h15M1 7h15M1 13h15"
              />
            </svg>
          </button>
          <div
            className={` bg-gray-200 w-full hidden xl:flex  relative justify-between sm:z-2  py-2 top-0 start-0 ${isActive ? ' sm:pe-3 sm:ps-44' : ' sm:ps-44 lg:pe-6'} `}
          >
            <div
              className={` w-auto items-center  max-[600px]:justify-end sm:flex   ${isActive ? 'max-[600px]:ms-32' : 'max-[600px]:ms-32'}`}
            >
              <ul
                className={`sm:flex flex-row max-[600px]:justify-end z-[99999] md:p-0  font-bold rounded-lg bg-gray-200 min-[1368px]:space-x-80 md:flex-row md:mt-0  md:bg-gray-200 ${isActive ? 'sm:justify-start flex-row-reverse ' : 'sm:justify-end lg:space-x-40'}`}
              >
                <li
                  className={`flex flex-wrap text-lg min-[1368px]:space-x-auto  ${isActive ? ' space-x-reverse space-x-3' : ' space-x-1  md:space-x-3  '}`}
                >
                  <Link
                    to={'/'}
                    className="block  text-customgreen rounded hover:text-gray-700 md:hover:bg-transparent md:hover:text-customgreen md:p-0 md:dark:hover:text-customgreen dark:hover:text-white md:dark:hover:bg-transparent   "
                  >
                    {t('nav_home')}
                  </Link>
                  <div className="text-customgreen">
                    <li className="dropdown  ">
                      {t('about')}
                      <KeyboardArrowDownIcon />

                      <ul className={`dropdown_menu `}>
                        {aboutNested?.map((data, index) => (
                          <Link
                            to={`${data?.path}`}
                            className=" relative  z-40 whitespace-nowrap flex flex-col hover:text-customgreen "
                            key={index}
                          >
                            <li className={` ${isSubmenuOpen && 'closed'} `} onClick={toggleSubmenu}>
                              {t(`${data?.name}`)}
                            </li>
                            <hr className="text-gray-400" />
                          </Link>
                        ))}
                      </ul>
                    </li>{' '}
                  </div>

                  <div className="text-customgreen ">
                    <li className="dropdown">
                      {t('Campaigns')}
                      <KeyboardArrowDownIcon />
                      <ul className="dropdown_menu">
                        <li>
                          {t('Seasonal Campaigns')}
                          <KeyboardArrowDownIcon className={`${isActive ? 'icon_AR' : 'icon_EN'}`} />
                          <ul className={`${isActive && 'sub_dropdown_menu_ar'}   sub_dropdown_menu dropdown_menu-4 `}>
                            {subCampaigns?.map((data, index) => (
                              <Link
                                key={index}
                                to={`/CampaignDonation/${data?.moduleID}`}
                                className="cursor-pointer relative  whitespace-nowrap flex flex-col hover:text-customgreen "
                              >
                                <li className={` ${isSubmenuOpen && 'closed'}`} onClick={toggleSubmenu}>
                                  {t(`${isActive ? data?.title_AR : data?.title_EN}`)}
                                </li>
                                <hr className="text-gray-400" />
                              </Link>
                            ))}
                          </ul>
                        </li>
                        <hr className="text-gray-400" />
                        {/* <Link to="/PermanentCampaigns">
                          <li className=" space_align">{t('Permanent Campaigns')}</li>
                        </Link> */}
                        <li>
                          {t('Permanent Campaigns')}
                          <KeyboardArrowDownIcon className={`${isActive ? 'icon_AR' : 'icon_EN'}`} />
                          <ul className={`${isActive && 'sub_dropdown_menu_ar'}   sub_dropdown_menu dropdown_menu-4 `}>
                            {subParmanent?.map((data, index) => (
                              <Link
                                key={index}
                                to={`/PermanentCampaigns/${data?.moduleID}`}
                                className="cursor-pointer relative  whitespace-nowrap flex flex-col hover:text-customgreen "
                              >
                                <li className={` ${isSubmenuOpen && 'closed'}`} onClick={toggleSubmenu}>
                                  {t(`${isActive ? data?.title_AR : data?.title_EN}`)}
                                </li>
                                <hr className="text-gray-400" />
                              </Link>
                            ))}
                          </ul>
                        </li>
                        <hr className="text-gray-400" />
                        {/* <Link to="/EmergencyCampaigns">
                          <li className=" space_align">{t('Emergency Campaigns')}</li>
                        </Link> */}
                        <li>
                          {t('Emergency Campaigns')}
                          <KeyboardArrowDownIcon className={`${isActive ? 'icon_AR' : 'icon_EN'}`} />
                          <ul className={`${isActive && 'sub_dropdown_menu_ar'}   sub_dropdown_menu dropdown_menu-4 `}>
                            {subEmergency?.map((data, index) => (
                              <Link
                                key={index}
                                to={`/EmergencyCampaigns/${data?.moduleID}`}
                                className="cursor-pointer relative  whitespace-nowrap flex flex-col hover:text-customgreen "
                              >
                                <li className={` ${isSubmenuOpen && 'closed'}`} onClick={toggleSubmenu}>
                                  {t(`${isActive ? data?.title_AR : data?.title_EN}`)}
                                </li>
                                <hr className="text-gray-400" />
                              </Link>
                            ))}
                          </ul>
                        </li>
                      </ul>
                    </li>
                  </div>

                  <div className="text-customgreen ">
                    {' '}
                    <li className="dropdown dropdown-4   cursor-pointer">
                      {t('Initiatives_and_programs')}
                      <KeyboardArrowDownIcon />

                      <ul className={` dropdown_menu `}>
                        {innitiativePrograms?.map((data, index) => {
                          return (
                            <Link
                              to={`${data?.path}`}
                              className="cursor-pointer relative  whitespace-nowrap flex flex-col hover:text-customgreen "
                              key={index}
                            >
                              <li
                                className={`sub_dropdown dropdown_item-${index + 1} ${isSubmenuOpen && 'closed'} space_align`}
                                onClick={toggleSubmenu}
                              >
                                {t(`${data?.name}`)}
                              </li>
                              <hr className="text-gray-400" />
                            </Link>
                          );
                        })}
                      </ul>
                    </li>
                  </div>

                  <div className="text-customgreen ">
                    <li className="dropdown dropdown-4  cursor-pointer">
                      {t('media').charAt(0).toUpperCase() + t('media').slice(1)}
                      <KeyboardArrowDownIcon />

                      <ul className={`   dropdown_menu dropdown_menu-4 `}>
                        {MediaCenter?.map((data, index) => (
                          <a
                            target="_blank"
                            href={data?.path}
                            className="cursor-pointer relative  whitespace-nowrap flex flex-col hover:text-customgreen "
                            key={index}
                          >
                            <li
                              className={`sub_dropdown dropdown_item-${index + 1} ${isSubmenuOpen && 'closed'} space_align`}
                              onClick={toggleSubmenu}
                            >
                              {t(`${data?.name}`)}
                            </li>
                            <hr className="text-gray-400" />
                          </a>
                        ))}
                        <Link onClick={toggleSubmenu} className="hover:text-customgreen " to={'/PressRelease'}>
                          <li className={`dropdown_item-5 ${isSubmenuOpen && 'closed'}`}>
                            {t('navItem_pressRelease')}
                          </li>
                        </Link>
                        <hr className="text-gray-400" />
                        <Link onClick={toggleSubmenu} className="hover:text-customgreen " to={'/PhotoGallery'}>
                          <li className={`dropdown_item-6 ${isSubmenuOpen && 'closed'}`}>
                            {t('navItem_photoGallery')}
                          </li>
                        </Link>
                        <hr className="text-gray-400" />
                        <Link onClick={toggleSubmenu} className="hover:text-customgreen " to={'/Infographic'}>
                          <li className={`dropdown_item-7 ${isSubmenuOpen && 'closed'}`}>
                            {' '}
                            {t('navItem_infographic')}
                          </li>
                        </Link>
                        <hr className="text-gray-400" />
                        <Link onClick={toggleSubmenu} className="hover:text-customgreen " to={'/SuccessStory'}>
                          <li className={`dropdown_item-8 ${isSubmenuOpen && 'closed'}`}>
                            {' '}
                            {t('navItem_successStory')}
                          </li>
                        </Link>
                        <hr className="text-gray-400" />
                        <Link onClick={toggleSubmenu} className="hover:text-customgreen " to={'/VideoGallery'}>
                          <li className={`dropdown_item-9 ${isSubmenuOpen && 'closed'}`}>
                            {' '}
                            {t('navItem_videoGallery')}
                          </li>
                        </Link>
                        <hr className="text-gray-400" />
                        <Link
                          onClick={toggleSubmenu}
                          className="hover:text-customgreen "
                          to={'/publicPortalDownloadcenter'}
                        >
                          <li className={`dropdown_item-10 ${isSubmenuOpen && 'closed'}`}> {t('Download Center')}</li>
                        </Link>
                      </ul>
                    </li>
                  </div>

                  <Link
                    to={'/VolunteerWithus'}
                    className="block  text-customgreen rounded hover:text-gray-700 md:hover:bg-transparent md:hover:text-customgreen md:p-0 md:dark:hover:text-customgreen dark:hover:text-white md:dark:hover:bg-transparent "
                  >
                    {t('Volunteer_us')}
                  </Link>
                </li>
              </ul>
            </div>
            {!token ? (
              <div className={`  ${isActive ? 'ps-2 max-[600px]:ms-32' : 'pe-2 max-[600px]:ms-32'} `}>
                <ul>
                  <li className={`flex space-x-1  ${isActive ? 'sm:pe-4 pe-4' : 'flex-row lg:ps-0 md:ps-4'} `}>
                    <div className="hidden sm:block">
                      {/* <PermContactCalendarIcon className="text-customgreen " /> */}
                    </div>

                    <span className={`flex space-x-1  flex-wrap ${isActive ? 'flex-row ' : 'flex-row '} `}>
                      <Link
                        to={'/donorLogin'}
                        className=" flex flex-row hover:scale-110 transition-transform duration-300 text-customgreen rounded hover:text-hovergreen md:hover:bg-transparent md:hover:text-customgreen md:p-0 md:dark:hover:text-customgreen   dark:hover:text-white md:dark:hover:bg-transparent  "
                      >
                        <svg
                          version="1.0"
                          xmlns="http://www.w3.org/2000/svg"
                          width="18.000000pt"
                          height="18.000000pt"
                          viewBox="0 0 350.000000 350.000000"
                          preserveAspectRatio="xMidYMid meet"
                        >
                          {' '}
                          <g
                            transform="translate(0.000000,300.000000) scale(0.050000,-0.050000)"
                            fill="#1d8b4b"
                            stroke="none"
                          >
                            {' '}
                            <path d="M2680 5960 c-187 -44 -329 -94 -420 -149 -38 -23 -97 -55 -129 -71 -110 -55 -416 -382 -498 -530 -629 -1145 264 -2509 1542 -2356 1139 136 1749 1342 1192 2356 -82 148 -388 475 -498 530 -32 16 -90 48 -129 72 -266 161 -728 226 -1060 148z" />{' '}
                            <path d="M2370 2467 c-1099 -158 -1942 -1062 -1985 -2129 l-10 -251 55 -44 55 -43 2515 0 2515 0 55 43 55 44 -10 251 c-31 769 -460 1444 -1195 1876 -103 60 -365 158 -560 209 -164 42 -1273 75 -1490 44z" />{' '}
                          </g>{' '}
                        </svg>
                      </Link>

                      <div className="hidden sm:block">
                        <LocalPhoneIcon
                          className={`text-customgreen hover:scale-110 transition-transform duration-300 hidden sm:block ${isActive ? 'sm:mx-2' : 'sm:mx-2'}`}
                        />
                      </div>
                      <Link
                        href="#"
                        className="  text-customgreen rounded hover:text-gray-700 md:hover:bg-transparent md:hover:text-customgreen md:p-0 md:dark:hover:text-customgreen   dark:hover:text-white md:dark:hover:bg-transparent "
                      >
                        {t('Call')}: 80014
                      </Link>
                      <Link
                        to="/add-cart"
                        className="block relative text-customgreen rounded hover:text-hovergreen md:hover:bg-transparent md:hover:text-customgreen md:p-0 md:dark:hover:text-customgreen   dark:hover:text-white md:dark:hover:bg-transparent "
                      >
                        <CardGiftcardIcon className="text-customgreen hover:scale-110 transition-transform duration-300 mx-1" />
                        <div className="top-2 absolute hover:scale-110 transition-transform duration-300 left-3">
                          <p className="flex h-1 w-1 items-center justify-center rounded-full bg-customgreen p-2.5 text-xs text-white">
                            {cartItems?.length}
                          </p>
                        </div>
                      </Link>
                    </span>
                  </li>
                </ul>
              </div>
            ) : (
              <li className="text-white text-xss flex gap-3">
                {/* <Link to={role === 'Admin' ? '/Admin' : `/user`} onClick={handleClick}>
                  <Button className="bg-gray-700 ">{username}</Button>
                </Link> */}
                <button>
                  <Link onClick={handleClick}>
                    <svg
                      version="1.0"
                      xmlns="http://www.w3.org/2000/svg"
                      width="18.000000pt"
                      height="18.000000pt"
                      viewBox="0 0 350.000000 350.000000"
                      preserveAspectRatio="xMidYMid meet"
                    >
                      {' '}
                      <g
                        transform="translate(0.000000,300.000000) scale(0.050000,-0.050000)"
                        fill="#1d8b4b"
                        stroke="none"
                      >
                        {' '}
                        <path d="M2680 5960 c-187 -44 -329 -94 -420 -149 -38 -23 -97 -55 -129 -71 -110 -55 -416 -382 -498 -530 -629 -1145 264 -2509 1542 -2356 1139 136 1749 1342 1192 2356 -82 148 -388 475 -498 530 -32 16 -90 48 -129 72 -266 161 -728 226 -1060 148z" />{' '}
                        <path d="M2370 2467 c-1099 -158 -1942 -1062 -1985 -2129 l-10 -251 55 -44 55 -43 2515 0 2515 0 55 43 55 44 -10 251 c-31 769 -460 1444 -1195 1876 -103 60 -365 158 -560 209 -164 42 -1273 75 -1490 44z" />{' '}
                      </g>{' '}
                    </svg>
                  </Link>
                  {/* {user?.name} */}
                </button>
                <Link
                  to="/add-cart"
                  className="block relative text-customgreen rounded hover:text-gray-700 md:hover:bg-transparent md:hover:text-customgreen md:p-0 md:dark:hover:text-customgreen   dark:hover:text-white md:dark:hover:bg-transparent  text-sm"
                >
                  <CardGiftcardIcon className="text-customgreen  hover:scale-110 transition-transform duration-300" />
                  <div className="top-2 absolute hover:scale-110 transition-transform duration-300 ">
                    <p className="flex h-1 w-1 items-center justify-center rounded-full bg-customgreen p-2.5 text-xs text-white">
                      {valuecart?.length}
                    </p>
                  </div>
                </Link>
                <button
                  type="button"
                  onClick={handleLogout}
                  className={` text-xs font-medium text-center inline-flex items-center  bg-transparent  text-customorange`}
                >
                  <svg
                    className="h-6 w-5 text-customorange"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M14 12h-4v-12h4v12zm4.213-10.246l-1.213 1.599c2.984 1.732 5 4.955 5 8.647 0 5.514-4.486 10-10 10s-10-4.486-10-10c0-3.692 2.016-6.915 5-8.647l-1.213-1.599c-3.465 2.103-5.787 5.897-5.787 10.246 0 6.627 5.373 12 12 12s12-5.373 12-12c0-4.349-2.322-8.143-5.787-10.246z" />
                  </svg>
                </button>
              </li>
            )}
            <div className={`  ${isActive ? ' ' : ''}   max-[600px]:z-50 max-[1024px]:w-full  md:flex  xl:hidden`}>
              <ul
                className={`${isActive ? 'flex-col items-end' : 'flex-col-reverse items-end'}   items-end p-3 md:p-0 sm:mt-4 font-bold   sm:flex-row md:mt-0 xl:bg-white`}
              >
                <MainMenu />
              </ul>
            </div>
          </div>

          <div className={` max-[1279px]:py-2 w-full  xl:py-1  ${isActive ? 'flex-row-reverse  ' : 'flex-row'} `}>
            {/* icons for mobile */}
            {!token ? (
              <span
                className={`xl:hidden flex justify-end   space-x-1 mx-2 flex-wrap ${isActive ? 'flex-row' : 'flex-row'} `}
              >
                <Link
                  onClick={handleClick}
                  className=" flex flex-row text-customgreen rounded hover:text-hovergreen md:hover:bg-transparent md:hover:text-customgreen md:p-0 md:dark:hover:text-customgreen md:mx-5  dark:hover:text-white md:dark:hover:bg-transparent  text-sm "
                >
                  <svg
                    version="1.0"
                    xmlns="http://www.w3.org/2000/svg"
                    width="18.000000pt"
                    height="18.000000pt"
                    viewBox="0 0 350.000000 350.000000"
                    preserveAspectRatio="xMidYMid meet"
                  >
                    {' '}
                    <g
                      transform="translate(0.000000,300.000000) scale(0.050000,-0.050000)"
                      fill="#1d8b4b"
                      stroke="none"
                    >
                      {' '}
                      <path d="M2680 5960 c-187 -44 -329 -94 -420 -149 -38 -23 -97 -55 -129 -71 -110 -55 -416 -382 -498 -530 -629 -1145 264 -2509 1542 -2356 1139 136 1749 1342 1192 2356 -82 148 -388 475 -498 530 -32 16 -90 48 -129 72 -266 161 -728 226 -1060 148z" />{' '}
                      <path d="M2370 2467 c-1099 -158 -1942 -1062 -1985 -2129 l-10 -251 55 -44 55 -43 2515 0 2515 0 55 43 55 44 -10 251 c-31 769 -460 1444 -1195 1876 -103 60 -365 158 -560 209 -164 42 -1273 75 -1490 44z" />{' '}
                    </g>{' '}
                  </svg>
                </Link>
                {/* <div className="hidden sm:block">
                        <LocalPhoneIcon
                          className={`text-customgreen hover:scale-110 transition-transform duration-300 hidden sm:block ${isActive ? 'sm:mx-2' : 'sm:mx-2'}`}
                        />
                      </div>
                      <Link
                        href="#"
                        className="  text-customgreen rounded hover:text-gray-700 md:hover:bg-transparent md:hover:text-customgreen md:p-0 md:dark:hover:text-customgreen   dark:hover:text-white md:dark:hover:bg-transparent "
                      >
                        {t('Call')}: 80014
                      </Link> */}
                <Link
                  to="/add-cart"
                  className="block relative text-customgreen rounded hover:text-gray-700 md:hover:bg-transparent md:hover:text-customgreen md:p-0 md:dark:hover:text-customgreen  dark:hover:text-white md:dark:hover:bg-transparent text-sm"
                >
                  <CardGiftcardIcon className="text-customgreen mx-1" />
                  <div className="top-0 absolute  left-3">
                    <p className="flex h-1 w-1 items-center justify-center rounded-full bg-customgreen p-2.5 text-xs text-white">
                      {!token ? cartItems?.length : valuecart?.length}
                    </p>
                  </div>
                </Link>
              </span>
            ) : (
              <span
                className={`xl:hidden flex justify-end   space-x-1 mx-2 flex-wrap ${isActive ? 'flex-row' : 'flex-row'} `}
              >
                <Link
                  onClick={handleClick}
                  className=" flex flex-row text-customgreen rounded hover:text-hovergreen md:hover:bg-transparent md:hover:text-customgreen md:p-0 md:dark:hover:text-customgreen md:mx-5  dark:hover:text-white md:dark:hover:bg-transparent  text-sm "
                >
                  <svg
                    version="1.0"
                    xmlns="http://www.w3.org/2000/svg"
                    width="18.000000pt"
                    height="18.000000pt"
                    viewBox="0 0 350.000000 350.000000"
                    preserveAspectRatio="xMidYMid meet"
                  >
                    {' '}
                    <g
                      transform="translate(0.000000,300.000000) scale(0.050000,-0.050000)"
                      fill="#1d8b4b"
                      stroke="none"
                    >
                      {' '}
                      <path d="M2680 5960 c-187 -44 -329 -94 -420 -149 -38 -23 -97 -55 -129 -71 -110 -55 -416 -382 -498 -530 -629 -1145 264 -2509 1542 -2356 1139 136 1749 1342 1192 2356 -82 148 -388 475 -498 530 -32 16 -90 48 -129 72 -266 161 -728 226 -1060 148z" />{' '}
                      <path d="M2370 2467 c-1099 -158 -1942 -1062 -1985 -2129 l-10 -251 55 -44 55 -43 2515 0 2515 0 55 43 55 44 -10 251 c-31 769 -460 1444 -1195 1876 -103 60 -365 158 -560 209 -164 42 -1273 75 -1490 44z" />{' '}
                    </g>{' '}
                  </svg>
                </Link>

                <Link
                  to="/add-cart"
                  className="block relative text-customgreen rounded hover:text-gray-700 md:hover:bg-transparent md:hover:text-customgreen md:p-0 md:dark:hover:text-customgreen  dark:hover:text-white md:dark:hover:bg-transparent text-sm"
                >
                  <CardGiftcardIcon className="text-customgreen mx-1" />
                  <div className="top-0 absolute  left-3">
                    <p className="flex h-1 w-1 items-center justify-center rounded-full bg-customgreen p-2.5 text-xs text-white">
                      {!token ? cartItems?.length : valuecart?.length}
                    </p>
                  </div>
                </Link>
                <button
                  type="button"
                  onClick={handleLogout}
                  className={` text-xs font-medium text-center inline-flex items-center  bg-transparent  text-customorange`}
                >
                  <svg
                    className="h-6 w-5 text-customorange"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M14 12h-4v-12h4v12zm4.213-10.246l-1.213 1.599c2.984 1.732 5 4.955 5 8.647 0 5.514-4.486 10-10 10s-10-4.486-10-10c0-3.692 2.016-6.915 5-8.647l-1.213-1.599c-3.465 2.103-5.787 5.897-5.787 10.246 0 6.627 5.373 12 12 12s12-5.373 12-12c0-4.349-2.322-8.143-5.787-10.246z" />
                  </svg>
                </button>
              </span>
            )}
            <div>
              <Link to="/" className="flex items-center  xl:items-start space-x-3 rtl:space-x-reverse">
                <div
                  data-aos="fade-down"
                  data-aos-easing="linear"
                  data-aos-duration="2500"
                  className={` absolute items-center pt-1 xl:bg-gray-50  xl:pt-8 xl:pb-6 mx-3 xl:rounded-b-3xl z-20 lg:px-5 top-0 justify-center`}
                >
                  <img src="/assets/logo.png" className=" lg:h-15 xl:h-20 h-10" alt="SHJC Logo" />
                </div>
              </Link>
            </div>

            <div className={`hidden justify-between shadow-md xl:flex ${isActive ? '  ps-40' : ' ps-40'}`}>
              <div
                className={`flex   items-center mb-2 hover:scale-105 transition-transform duration-300  md:order-2  max-[600px]:right-5 ${isActive ? 'ps-4 ' : ' pe-4'} `}
              >
                <Link to={'/GeneralDonation'}>
                  <button
                    type="button"
                    className="text-white  max-[600px]:hidden px-4  h-10 bg-gradient-to-r  from-customgreen to-customorange hover:from-customorange hover:to-customgreen focus:ring-4 focus:outline-none focus:ring-customgreen font-bold rounded-full   text-lg   text-center dark:bg-customgreen dark:hover:bg-hovergreen dark:focus:ring-customgreen"
                  >
                    {t('General Donation')}
                  </button>
                </Link>
              </div>
              <div className={`max-[600px]:z-50 xl:visible xs:invisible max-[600px]:w-11/12 `}>
                <ul
                  className={`${isActive ? 'flex-col ' : 'flex-col-reverse '} items-end p-2 md:p-0 sm:mt-4 font-bold   rounded-lg bg-gray-50   md:flex-row md:mt-0 md:bg-white`}
                >
                  {/* Desktop Main Menu  */}
                  <MainMenu />
                </ul>
              </div>
            </div>
          </div>
        </nav>
      </header>
    </>
  );
};

export default PublicPortalTopMenu;
